"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateCoSellerDto = instanceOfUpdateCoSellerDto;
exports.UpdateCoSellerDtoFromJSON = UpdateCoSellerDtoFromJSON;
exports.UpdateCoSellerDtoFromJSONTyped = UpdateCoSellerDtoFromJSONTyped;
exports.UpdateCoSellerDtoToJSON = UpdateCoSellerDtoToJSON;
exports.UpdateCoSellerDtoToJSONTyped = UpdateCoSellerDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateCoSellerDto interface.
 */
function instanceOfUpdateCoSellerDto(value) {
    return true;
}
function UpdateCoSellerDtoFromJSON(json) {
    return UpdateCoSellerDtoFromJSONTyped(json, false);
}
function UpdateCoSellerDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'coSellers': json['coSellers'] == null ? undefined : json['coSellers'],
    };
}
function UpdateCoSellerDtoToJSON(json) {
    return UpdateCoSellerDtoToJSONTyped(json, false);
}
function UpdateCoSellerDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'coSellers': value['coSellers'],
    };
}
